<template>
    <div class="scc-result-page">
        <AppSection
            backgroundImage="https://cdn.lotify.com/44b81bd9-f017-43a5-816e-bb4fa1b3311e/abebaf35-8962-4f8b-a701-3424fb93c466/a6f15413-1227-4132-ab8d-145a483825c2/knvb_placeholder_2.jpg"
            backgroundColor="secondary"
            topPadding="medium"
            bottomPadding="medium"
        >
            <Container type="row" alignment="start" verticalPadding="large">
                <Container :lg="7">
                    <TicketCheckerAlternative
                        :game="game"
                        :parentGame="parentGame"
                        :drawings="drawings"
                        :parentDrawings="parentDrawings"
                        title="Heb je gewonnen?"
                        titleWon="Gefeliciteerd! Jij wint..."
                        titleLost="Volgende keer beter..."
                        ticketLabel="Vul hier je lotnummer in"
                        checkButtonText="Check je lot(en)"
                        textWon="Houd je brievenbus of mailbox in de gaten, want je krijgt persoonlijk bericht over je prijs!"
                        textLost="Met jouw deelname heb je een belangrijke bijdrage geleverd aan het bestaan van jouw gesteunde amateurvoetbalclub, daarvoor dankjewel!"
                    >
                    </TicketCheckerAlternative>
                </Container>
            </Container>
        </AppSection>
        <AppSection backgroundColor="white" topPadding="medium" bottomPadding="medium">
            <Container verticalPadding="none" horizontalPadding="none">
                <DrawingResultAlternative
                    :game="game"
                    :parentGame="parentGame"
                    :drawings="drawings"
                    :parentDrawings="parentDrawings"
                >
                </DrawingResultAlternative>
            </Container>
        </AppSection>
    </div>
</template>

<script>
export default {
    name: 'ResultPage',
    __editor: {
        requiredData: ['game', 'parentGame', 'drawings', 'parentDrawings'],
    },
    props: {
        game: {
            type: Object,
        },
        parentGame: {
            type: Object,
        },
        drawings: {
            type: Array,
        },
        parentDrawings: {
            type: Array,
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
